/* eslint-disable @typescript-eslint/no-explicit-any */
enum fieldTypes {
    text="text",
    textArea="textArea",
    number="number",
    select="select",
    wysiwyg="wysiwyg"
}
export class BannerDIYFormItem {
    fieldType: string;
    id: string;
    name: string;
    label: string;
    placeHolder: string;
    validation: string;
    allowedTags: string[]
    value: string;
    wysiwyg: string[];
    maxLength: number;
    required = false;
    constructor(data:any) {
        this.fieldType = typeof data.fieldType!=='undefined' && Object.keys(fieldTypes).indexOf(data.fieldType)>=0 ? data.fieldType : fieldTypes.text;
        this.id = typeof(data.id)!=='undefined' ? data.id : null;
        this.name = typeof(data.name)!=='undefined' ? data.name : null;
        this.label = typeof(data.label)!=='undefined' ? data.label : null;
        this.placeHolder = typeof(data.placeHolder)!=='undefined' ? data.placeHolder : null;
        this.validation = typeof(data.validation)!=='undefined' ? data.validation : null;
        this.allowedTags = typeof(data.allowedTags)!=='undefined' ? data.allowedTags : [ 'b', 'br', 'i', 'strong', 'u' ]
        this.value = typeof(data.value)!=='undefined' ? data.value : '';
        this.wysiwyg = typeof(data.wysiwyg)!=='undefined' ? data.wysiwyg : [];
        this.maxLength = typeof data.maxLength !=='undefined' ? data.maxLength: 100;
        this.required = typeof data.required !== 'undefined' ? data.required : false;
    }
}